import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
// import { useBrandsUIContext } from "../BrandsUIContext";

const prepareFilter = (queryParams, values) => {
  const { searchText } = values;
  const newQueryParams = { ...queryParams };

  newQueryParams.searchKey = searchText;
  return newQueryParams;
};

export function StockAlertFilter({ setQueryParams, queryParams, listLoading }) {
  // Brands UI Context
  //   const brandsUIContext = useBrandsUIContext();
  //   const brandsUIProps = useMemo(() => {
  //     return {
  //       setQueryParams: brandsUIContext.setQueryParams,
  //       queryParams: brandsUIContext.queryParams,
  //     };
  //   }, [brandsUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(queryParams, values);
    if (!isEqual(newQueryParams, queryParams)) {
      newQueryParams.pageNumber = 1;
      setQueryParams(newQueryParams);
    }
  };
  const intl = useIntl();
  let formattedValue = intl.formatMessage({ id: "Search" });

  return (
    <>
      <Formik
        initialValues={{
          searchText: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({ values, handleSubmit, handleBlur, handleChange, setFieldValue }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-4">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder={formattedValue}
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>
                    <FormattedMessage id="Search" defaultMessage="Search" />
                  </b>
                  <FormattedMessage id="by product name, SKU/UPC" defaultMessage=" by product name, SKU/UPC" />
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
